import { CrownSimpleIcon } from '@phosphor-icons/react';
import { Button } from '@shadcn/components/button';
import { cn } from '@shadcn/lib/utils';

export function ProIcon({
  size,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <CrownSimpleIcon
      className={cn(
        'text-rag-amber',
        className,
        size ? `size-${size}` : 'size-4',
      )}
      weight="fill"
    />
  );
}

export default function UpgradeButton({ onClick, className }: { onClick: () => void; className?: string }) {
  return (
    <Button onClick={onClick} className={cn('gap-2', className)}>
      <ProIcon size={5} />
      Upgrade to Pro
    </Button>
  );
}
